export const DATA_TYPE_SCALAR = 1;
export const DATA_TYPE_ARRAY = 2;
export const DATA_TYPE_VECTOR = 3;
export const DATA_TYPE_OTHER = 4;

export interface OverviewSelections {
    station_ids: string[]
    stations_in_same_order: { id: number, name: string }[]
    sub_builds: { id: number, name: string }[]
    employees: string[]
    hardware_versions: string[],
    mp_batch_serials: {
        uuid: string,
        serial: string,
        start: string,
        end: string
    }[],
    data_filters: { id: number, name: string, description: string }[]
}

export interface OverviewGeneral {
    sequences: {
        [status: number]: {
            count: number,
            times: number
        }
    },
    total_number: number,
    fail_serials: string[],
    unique_serial_number: number
}

export interface OverviewDaily {
    [dayHour: string]: {
        testing_times: number,
        testing_times_pass: number,
        testing_times_fail: number,
        testing_times_invalid: number,
        testing_times_stopped: number,
        overheads: number[],
        breaks: number,
        pass: number,
        fail: number,
        invalid: number,
        stopped: number
    }
}

export interface OverviewMeasurement {
    measurements: { measurement_name: string, export_file_name: string, measurement_key: string, pass_number: number, fail_number: number, invalid_number: number, total: number, average_time: number, median_time: number, data_type: number }[]
}

export interface GipbScotterData {
    value: number;
    serial_number: string;
    file_name: string;
    status: number;
};

export interface VectorPlotData {
    results: string;
    values: number[][];
    serial_number: string;
    file_name: string;
    status: number;
};


export interface TestingFile {
    id: number,
    date: string,
    file_path: string,
    result_id: number,
    employee_id: string,
    factory: string,
    firmware_version: string,
    hardware_version: string,
    order: string,
    product: string,
    programmer_sn: string,
    serial_number: string,
    status: number,
    update_status: number,
    file_status: number,
    testing_station_name: string,
    total_time: number,
    testing_station_id: string,
    production_manager: string,
    programmer_name: string,
    content_md5: string,
    fail_measurements?: string,
    sequence_parameters?: { key: string, name: string, value: string }[],
    is_deleting?: boolean,
    re_serial_number?: string
}

export interface MeasurementStatistics {
    name: string,
    key: string,
    export_file_name: string,
    fail_count: number,
    pass_count: number,
    invalid_count: number,
    unknown_count: number,
}

export interface Measurement {
    id: number;
    file_id: number;
    measurement_type: string;
    data_type: number;
    measurement_name: string;
    parent_measurement_id?: string;
    measurement_id: string;
    measurement_key: string;
    export_file_name: string;
    result_unit: string;
    limit_unit: string;
    measurement_time: number;
    measurement_date: string;
    attempted: number;
    measurement_status: number;
}

export interface MeasurementData {
    measurement_id: number;
    index: number;
    channel: number;
    limits: LimitData<string | number | number[] | VectorData>;
    result: string | number | number[] | VectorData;
    gpib_channel_names: string;
}

export interface DropdownOption {
    id: number;
    name: string;

    children: DropdownOption[];
}

export interface VectorData {
    x_values: number[];
    y_values: number[]
}

export interface LimitData<T> {
    lower?: T,
    upper?: T
}


export interface MeasurementPlotInfo {
    measurement_name: string;
    channels: number[];
    limits: any[];
    parameter_size: number;
    limit_unit: string;
    result_unit: string;
}

export interface MeasurementPlot {
    file_id: number;
    file_name: string;
    serial_number: string;
    measurement_id: number;
    status: number;
    result: any;
    value?: number;
    values?: number[][];
    vibrateX?: number;
}

export interface ParameteOverTime {
    file_id: number;
    date: Date;
    file_path: string;
    testing_station_id: string;
    serial_number: string;
    status: number;
    value: number;
    lower: number;
    upper: number;
}


export interface HistogramData {
    status: number;
    value: number;
}


export interface UploadStatus {
    product: string;
    order: string;
    testing_station_name: string;
    testing_station_id: string;
    todos: number;
    errors: number;
    uploaded: number;
    updated_at: string;
}

export interface MatchSerialResult {
    batch_id: number;
    file_id: number;
    file_id2: number;
    sn: string;
    sn2: string;
    created_at: string;
    operator: string
}

export interface MatchingBatchListItem {
    id: number,
    result_id: number,
    product: string,
    order: string,
    testing_station: string,
    created_at: string
    operator: string
}


export interface MatchingBatchPlotResult {
    name: string,
    xs: string,
    limit: string,
    paireds: {
        name: [string, string],
        ys: string,
        ys2: string,
        status: number
    }[]
}

export interface MatchingBatchPlotData {
    xs: number[],
    limit: number[],
    xDomain: [number, number],
    yDomain: [number, number],
    absYDomain: [number, number]
}


export interface MatchingBatchPlotDataPaired {
    name: [string, string],
    ys: number[],
    ys2: number[],
    abs: number[],
    status: number
}

export const MATCHING_SERIAL_STATUS_NORMAL = 1;
export const MATCHING_SERIAL_STATUS_DELETED = 2;
